var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardIcon = function SvgCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#9F9FA8",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.005 5.5H2.996a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h26.009a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3m-26.01 2h26.009a1 1 0 0 1 1 1v2H1.995v-2c0-.552.449-1 1-1m26.01 17H2.996a1 1 0 0 1-1-1v-9h28.009v9a1 1 0 0 1-1 1"
  })));
};
export default SvgCardIcon;